/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum Status266Enum {
    DOWNLOADED = 'downloaded',
    COMPLETED = 'completed',
    FAILED = 'failed',
}